import { ComponentsOverrides, ComponentsProps, Theme } from '@mui/material';

export const MuiSvgIcon: {
    styleOverrides: ComponentsOverrides<Theme>['MuiSvgIcon'];
    defaultProps?: ComponentsProps['MuiSvgIcon'];
} = {
    styleOverrides: {
        fontSizeLarge: {
            fontSize: 32,
        },
    },
    defaultProps: {
        fontSize: 'small',
    },
};
